import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AportacionDIPoseedorControllerService, AportacionDiAcuerdosGestoresControllerService } from 'api-rest';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'managers-agreements-indirect-agreement-contributions-dis-upload-dialog',
  templateUrl: './indirect-agreement-contributions-dis-upload-dialog.component.html',
  styleUrls: ['./indirect-agreement-contributions-dis-upload-dialog.component.scss']
})
export class IndirectAgreementContributionsDisUploadDialogComponent {
formGroup!: FormGroup;
  tiposDocumento: any[] = [];
  adjuntosBlob: Array<any> = [];
  botonEstado: boolean = false;
  flagTooltip: boolean = false;

  poseedor:any;
  gestorResiduo:any;
  isPoseedor:boolean = false;
  isGestor:boolean = false;
  nimaPoseedorArray: any[] = [];
  nimaGestorArray: any[] = [];

  documento: File | undefined;
  isDragging = false;
  files: File[] = [];

  grid: any[] = [];
  headArray: any[] = [
    {
      Head: 'Documento',
      FieldName: 'name',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params:'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '2',
      permanent: true,
    },
  ];

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<IndirectAgreementContributionsDisUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private aportacionPoseedorCtrSrv: AportacionDIPoseedorControllerService,
     private aportacionDiAcuerdosGestoresSrv: AportacionDiAcuerdosGestoresControllerService
  ) {
    this.poseedor = this.data.poseedorOrGestor.poseedor;
    this.gestorResiduo = this.data.poseedorOrGestor.gestorResiduo;
    if(this.poseedor){
      this.isPoseedor = true;
    }else if(this.gestorResiduo){
      this.isGestor = true;
    }

    this.inicializarForm();
  }

  ngOnInit(): void {
    if(this.poseedor){
      this.nimaPoseedorArray = [this.poseedor];
    }
    if(this.gestorResiduo){
      this.nimaGestorArray = [this.gestorResiduo];
    }
  }

  inicializarForm() {
    this.formGroup = this.formBuilder.group({
      poseedor: [
        { value: `${this.poseedor?.nima} - ${this.poseedor?.razonSocial}`, disabled: true },
      ],
      nimaGestor: [
        { value: `${this.gestorResiduo?.nima} - ${this.gestorResiduo?.razonSocial}`, disabled: true },
      ],
      esAportacionSDDRCA: [
        { value: false, disabled: false },
      ],

    });

  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

  attachAdjunto(archivos: any): void {
    if (archivos != null && archivos != undefined && archivos.length > 0) {
      this.addFiles(archivos);
    }
  }

  //addFile(){
  //  if(this.documento){
  //    //Comporbar que no exista un fichero con el mismo nombre
  //    if(this.adjuntosBlob.filter((item) => item.name == this.documento?.name).length > 0){
  //      this.snackBarSrv.showSnackBar(
  //        'Ya se ha añadido un documento con el mismo nombre.',
  //        'error'
  //      );
  //    }else{
  //      this.grid = [];
  //      this.adjuntosBlob.push(this.documento);
  //      this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
  //      this.documento = undefined;
  //    }
  //
  //  }
  //}

  action(event: any) {
    if (event.nameButton == 'delete') {
      //Borrar registro
      this.deleteFile(event);
    }
  }

  canAccessDelete(): boolean {
    return true;
  }

  deleteFile(element:any){
    this.adjuntosBlob = this.adjuntosBlob.filter((item: any) => item.name !== element.name);
    this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
  }

  saveData(){
    if (this.adjuntosBlob == null || this.adjuntosBlob == undefined || this.adjuntosBlob.length == 0) {
      this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
      return;
    }
    this.spinnerSrv.loadingShow();
    const aportacionSDDRCA = this.formGroup.get('esAportacionSDDRCA')?.value ? true : false;
    const cargaAportPayload = {poseedor: this.poseedor, gestorResiduos: this.gestorResiduo, esCreadoPoseedor: this.isPoseedor, aportacionSDDRCA: aportacionSDDRCA, esMultipleDI: this.data.esMultipleDI};
    this.aportacionDiAcuerdosGestoresSrv.cargaMasiva(cargaAportPayload, this.adjuntosBlob).subscribe({
       next: (response) => {
         this.spinnerSrv.loadingHide();
         this.snackBarSrv.showSnackBar('Las aportaciones se han registrado correctamente y comenzarán a cargarse en el buscador de forma progresiva, ya que el proceso de lectura puede tardar unos minutos. Si necesitamos que realice alguna acción adicional, nos pondremos en contacto con usted  por correo electrónico.', 'success');
         this.dialogRef.close(true);
       },
       error: () => {
         this.spinnerSrv.loadingHide();
         this.snackBarSrv.showSnackBar('Ha ocurrido un error al crear las aportaciones.', 'error');
       },
     });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFiles(input.files);
    }
  }

  addFiles(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      const pFile = fileList.item(i);
      if(this.isValidFile(pFile)){
        if(this.adjuntosBlob.filter((item) => item.name == pFile?.name).length > 0){
          this.snackBarSrv.showSnackBar(
            'Ya se ha añadido un documento con el mismo nombre.',
            'error'
          );
        }else{
          this.grid = [];
          this.adjuntosBlob.push(pFile);
          this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
          this.documento = undefined;
        }
      }
    }
  }

  isValidFile(archivo: File | null){
    let isValid = false;
    if (archivo != null) {
      const isPDF = archivo.type === 'application/pdf' && archivo.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
        this.snackBarSrv.showSnackBar(
          'Solo se permiten archivos pdf',
          'error'
        );
      } else if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      }else{
        isValid = true;
      }
    }

    return isValid;
  }
}
